import { createGetAsyncSlice } from '@sonar-software/xuder';
import { getDataSecurityAccessComparison } from '@api/data-security';

export const getCoreDataSecurityAccessComparisonSlice = createGetAsyncSlice({
	name: 'CoreDataSecurityAccessComparison',
	receive: true,
	request: true,
	requestHandler: getDataSecurityAccessComparison,
	retainDataOnRequest: true
});
